var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found content"},[_c('div',{staticClass:"w3-row"},[_c('div',{staticClass:"w3-col w3-center"},[_c('h2',[_vm._v(_vm._s(_vm.$text['notfound']['notfound']))]),_c('v-back-button',{staticClass:"w3-margin"})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }